module.exports = __webpack_public_path__ + "img/agrotechnologia_logo.127df7b6.svg";